"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.gameForm = void 0;
exports.gameForm = {
    isEnable: false,
    componentStyle: {
        backgroundColor: 'ffffff',
    },
    title: 'Fill in this form to start playing',
    titleStyle: {
        color: '000000',
        fontSize: '16px',
        textAlign: 'center',
    },
    termsText: 'By starting the game you accept our Terms & Conditions',
    termsTextStyle: {
        color: '000000',
        fontSize: '16px',
        textAlign: 'center',
    },
    isCheckBoxRequired: true,
    submitButtonText: 'START GAME',
    submitButtonTextStyle: {
        color: 'FFFFFF',
        backgroundColor: '46bb97',
        fontSize: '24px',
    },
};
